import { SettingsLayout } from "@/components/layout/SettingsLayout";
import { MatrixUpload } from "@/components/matrix/MatrixUpload";

export function MatrixUploadPage() {
  return (
    <SettingsLayout>
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold">Matrix Upload</h2>
          <p className="text-muted-foreground">
            Upload the Master Matrix spreadsheet to sync categories, metrics, profiles, and weights.
          </p>
        </div>
        <MatrixUpload />
      </div>
    </SettingsLayout>
  );
}
